export default (that) => [
  {
    text: that.$l('btn_view_detail') || '查看详情',
    menuType: 'detail',
    icon: 'el-icon-view',
  },
  {
    text: that.$l('btn_container_mgmt') || '分柜管理',
    menuType: 'container',
    icon: 'el-icon-s-operation',
    divided: true,
    disabled: (row) => row.shipmentStatus !== 'N',
    allow: 'CM',
  },
  {
    text: that.$l('btn_booking_mgmt') || '订舱管理',
    menuType: 'booking',
    icon: 'el-icon-s-order',
    disabled: (row) => row.shipmentStatus !== 'N',
    allow: 'BM',
  },
  {
    text: that.$l('INDEX.btn_export') || '导出',
    menuType: 'export',
    icon: 'el-icon-download',
    divided: true,
    allow: 'E',
  },
]
